import React, { useState, useContext } from 'react';
import { ArrowLeftCircle, ArrowRightCircle, CheckCircle, XCircle } from 'react-feather';

import { BuildPath } from  '@/helpers/Paths';
import { eventReplyStatusEnum, user } from  '@/interfaces/planner';
import { PlannerContext } from '@/context/PlannerContext';
import { hoursAndMinutesBetweenTwoDates } from  '@/helpers/Date';

interface ScrollingAttendeesListProps {
    awaitingUsers: user[],
    getAwaitingUsers: (skip?:number, top?:number, refresh?: boolean) => void,
    eventWorkflowId?:number,
    processingUsers: number[],
    setProcessingUsers: (val: number[]) => void,
    totalAwaitingUsers: number,
    isFull:boolean
    eventTimeRemaining?: number,
    isCancelled: boolean,
    isClosed:boolean
}


const ScrollingAttendeesList = ({awaitingUsers, getAwaitingUsers, eventWorkflowId, processingUsers, setProcessingUsers, totalAwaitingUsers, isFull, eventTimeRemaining, isCancelled, isClosed}:ScrollingAttendeesListProps) => {

    const [currentPosition, setCurrentPosition] = useState<number>(0);

    const { approveAwaiting } = useContext(PlannerContext);

    const [isLoading, setIsLoading] = useState<boolean>(false)

    

    function getTranslatePositon(){
        return -(currentPosition * 240)
    }

    function next() {
        if (currentPosition >= awaitingUsers.length -1) {
            return
        }

        // if second last card, check for more cards
        if(currentPosition === awaitingUsers.length -2 && awaitingUsers.length < totalAwaitingUsers) {
            getAwaitingUsers(awaitingUsers.length, 8, false)
        }
        
        setCurrentPosition(currentPosition + 1)
    }
    
    function previous() {
        if (currentPosition <= 0) {
            return
        }
        
        setCurrentPosition(currentPosition - 1)
    }

    async function processApplication(action: 'approved' | 'rejected', workflowId: number, responseId: number) {
        setIsLoading(true) 
        approveAwaiting(workflowId, responseId, action)
        .then(() => {
            getAwaitingUsers(0, awaitingUsers.length, true);
        })
        .catch(() => {
            // show toast
        })
        .finally(() => {
            setIsLoading(false);
        })
    }

    function canConfirm(user: user){
        // if event is full you cannot attend
        if (isFull || isCancelled) {
            return false
        }

        if(eventTimeRemaining) {
            
            const eventDuration = hoursAndMinutesBetweenTwoDates(user.reply.endSelection, user.reply.startSelection)
            
            let eventDecimal = +eventDuration.split(':')[0]

            if(eventDuration.includes(':')) {
                eventDecimal += +eventDuration.split(':')[1]/60
            }
             

            if (eventDecimal > eventTimeRemaining) {
                return false
            }
        }
        

      return true
    }

    if(awaitingUsers?.length <= 0 || isCancelled) {
        return <></>
    }

    return (
        <div className='approval-required'>
            <div className='approval-required-title-wrapper' style={{display: 'flex', justifyContent:'space-between'}}>
            <h3>Approval Required</h3>

            <span style={{display:'flex'}}>
                <button
                    disabled={currentPosition <= 0}
                    className='no-style-btn'
                    onClick={previous}
                    style={{marginRight:'4px'}} 
                    aria-label='previous'
                >
                    <ArrowLeftCircle size={12} color={currentPosition <= 0 ? '#6a6f75' : '#02b5eb'}/>
                </button>
                <button 
                    disabled={currentPosition >= awaitingUsers.length -1}
                    className='no-style-btn'
                    onClick={next}
                    aria-label='next'
                >
                    <ArrowRightCircle size={12} color={currentPosition >= awaitingUsers.length -1 ? '#6a6f75' : '#02b5eb'}/>
                </button>
            </span>
            </div>
            <ul className='approval-required-list' style={{transform: `translate3d(${getTranslatePositon()}px, 0, 0)`}}>
                {awaitingUsers.map((user) => 
                    <li key={`attendee-${user.id}`} className={'awaiting-user-container'}>
                        <span className='pic-and-name-wrapper'>
                            <img 
                                className='profile-pics'
                                alt={`${user.displayName} profile pic`}
                                src={user.profilePicUrl ||`${BuildPath()}/images/locker/icons/default-profile.png`}
                                onError={(e) => (e.target as HTMLImageElement).src=`${BuildPath()}/images/locker/icons/default-profile.png`}
                            />
                            <span className='scrolling-display-name'>{user.displayName}</span>
                        </span>
                        <span className='awaiting-button-wrapper'style={{display:'flex'}}>
                            {user.eventReplyStatus === eventReplyStatusEnum.Processing || processingUsers.includes(user.id)
                                ? <img src={`${BuildPath()}/images/userupload/rolling.svg`} alt='executing' style={{height: '12px'}}/>
                                : <>
                                    {canConfirm(user) && <button
                                        disabled={isLoading}
                                        className='no-style-btn'
                                        style={{marginRight: '8px'}}
                                        onClick={() => {
                                            processApplication('approved', eventWorkflowId, user.reply.workflowResponseId)
                                            setProcessingUsers([...processingUsers, user.id])
                                        }}
                                    >
                                        <CheckCircle size={12} color={'#10b981'}/>
                                    </button>}
                                    <button 
                                        disabled={isLoading}
                                        className='no-style-btn'
                                        onClick={() => {
                                            processApplication('rejected', eventWorkflowId, user.reply.workflowResponseId)
                                            setProcessingUsers([...processingUsers, user.id])
                                        }}
                                    >
                                        <XCircle size={12} color={'#e02020'}/>
                                    </button>
                                </>
                            
                            }
                        </span>
                    </li>             
                )}
            </ul>
        </div>
    )
}

export default ScrollingAttendeesList